import { products } from '../../../mocks/britfit';

export default function Products() {
  return (
    <section id="products" className="bg-[#111111] py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div>
            <span className="inline-block border border-white/20 text-white/60 text-xs font-semibold px-4 py-1.5 rounded-full mb-5">
              Premium Brands
            </span>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" style={{ fontFamily: 'Syne, sans-serif' }}>
              Tyres From the<br />
              World&apos;s Leading<br />
              Manufacturers
            </h2>
          </div>
          <p className="text-stone-400 text-sm leading-relaxed max-w-xs">
            We source only from trusted, industry-leading brands. Every tyre we fit meets the highest standards of safety and performance.
          </p>
        </div>

        {/* Brand logos strip */}
        <div className="flex flex-wrap gap-4 md:gap-6 mb-12">
          {['Michelin', 'Pirelli', 'Continental', 'Bridgestone', 'Goodyear', 'Dunlop'].map((b) => (
            <span
              key={b}
              className="border border-white/10 text-white/40 text-xs font-semibold px-4 py-2 rounded-full"
            >
              {b}
            </span>
          ))}
        </div>

        {/* Product cards - horizontal scroll */}
        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4 md:mx-0 md:px-0">
          {products.map((product) => (
            <div
              key={product.id}
              className="flex-none w-60 md:w-64 bg-[#1C1C1C] rounded-2xl overflow-hidden cursor-pointer group"
            >
              {/* Product image */}
              <div className="w-full h-52 bg-[#F5F1E8] overflow-hidden flex items-center justify-center p-4">
                <img
                  src={product.image}
                  alt={`${product.brand} ${product.model}`}
                  className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Info */}
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[#6EE7B7] text-xs font-semibold">{product.tag}</span>
                  <span className="text-white text-lg font-bold">{product.price}</span>
                </div>
                <h3 className="text-white font-bold text-sm mb-1" style={{ fontFamily: 'Syne, sans-serif' }}>
                  {product.brand}
                </h3>
                <p className="text-stone-400 text-xs">{product.model}</p>
                <p className="text-stone-500 text-xs mt-0.5">{product.size}</p>

                <button className="mt-4 w-full bg-[#1B4332] hover:bg-[#145228] text-white text-xs font-semibold py-2.5 rounded-xl cursor-pointer transition-colors whitespace-nowrap">
                  Get a Quote
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <p className="text-stone-400 text-sm mb-4">Don&apos;t see your size? We stock thousands of options.</p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 border border-white/20 text-white text-sm font-semibold px-8 py-3 rounded-full cursor-pointer hover:border-white/50 transition-colors whitespace-nowrap"
          >
            Enquire About Your Tyre <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
